module.exports = __webpack_public_path__ + "media/images/front/dplus_introduce-431cf5d7fadea53e0e9dd78e0a4dd7d9.png";